import React from 'react';
import Layout from '../components/Layout/Layout';
import Seo from '../components/Seo/Seo';
import Partners from '../components/Partners/Partners';
import COS_FOOTER_SANTE from '../images/COS_FOOTER_SANTE.jpg';

const Partenaires = () => {
  return (
    <Layout logo={COS_FOOTER_SANTE}>
      <Seo title="COS - Partenaires" description="COS - Partenaires" />
      <Partners />
    </Layout>
  );
};

export default Partenaires;
